import React, { FC } from 'react';
import { Box, Checkbox, FormControlLabel, TextField } from '@mui/material';
import {
  AdditionalFieldKey,
  AdditionalFieldsModel,
  ADDITIONAL_FIELDS_META,
} from '../../model';
import { AdditionalFieldsSectionProps } from '../../types/additionalFieldsForm';
import { NumberMaskField } from '../NumberMaskField';
import { useAdditionalFieldsHandlers } from '../../hooks/useAdditionalFieldsHandlers';

type MonthlyBreakdownSectionProps = AdditionalFieldsSectionProps & {
  setValues: React.Dispatch<React.SetStateAction<AdditionalFieldsModel>>;
  debouncedSaveField: (
    key: AdditionalFieldKey,
    value: AdditionalFieldsModel[AdditionalFieldKey],
  ) => void;
} & Pick<
    ReturnType<typeof useAdditionalFieldsHandlers>,
    | 'handleTextChange'
    | 'handleBlur'
    | 'handleTextKeyDown'
    | 'handleBooleanChange'
  >;

export const MonthlyBreakdownSection: FC<MonthlyBreakdownSectionProps> = ({
  values,
  isFieldsDisabled,
  setValues,
  debouncedSaveField,
  handleBooleanChange,
  handleTextChange,
  handleBlur,
  handleTextKeyDown,
}) => (
  <>
    <Box minHeight={56} display="flex" alignItems="flex-end">
      <NumberMaskField
        fullWidth
        label={ADDITIONAL_FIELDS_META.clientBudgetCurrentMonth.label}
        value={values.clientBudgetCurrentMonth}
        disabled={isFieldsDisabled}
        onChange={(num) => {
          setValues((prev) => ({
            ...prev,
            clientBudgetCurrentMonth: num,
          }));
          debouncedSaveField('clientBudgetCurrentMonth', num);
        }}
      />
    </Box>
    <Box minHeight={56} display="flex" alignItems="center">
      <FormControlLabel
        control={
          <Checkbox
            sx={{ py: 0 }}
            size="small"
            checked={Boolean(values.hasMonthlyBreakdown)}
            disabled={isFieldsDisabled}
            onChange={handleBooleanChange('hasMonthlyBreakdown')}
          />
        }
        label={ADDITIONAL_FIELDS_META.hasMonthlyBreakdown.label}
      />
    </Box>
    <Box minHeight={56} display="flex" alignItems="flex-end">
      <NumberMaskField
        fullWidth
        label={ADDITIONAL_FIELDS_META.clientBudgetPreviousPeriods.label}
        value={values.clientBudgetPreviousPeriods}
        disabled={isFieldsDisabled}
        onChange={(num) => {
          setValues((prev) => ({
            ...prev,
            clientBudgetPreviousPeriods: num,
          }));
          debouncedSaveField('clientBudgetPreviousPeriods', num);
        }}
      />
    </Box>
    <Box minHeight={56} display="flex" alignItems="flex-end">
      <NumberMaskField
        fullWidth
        label={ADDITIONAL_FIELDS_META.clientBudgetCurrentMonthFromBooking.label}
        value={values.clientBudgetCurrentMonthFromBooking}
        disabled={isFieldsDisabled}
        onChange={(num) => {
          setValues((prev) => ({
            ...prev,
            clientBudgetCurrentMonthFromBooking: num,
          }));
          debouncedSaveField('clientBudgetCurrentMonthFromBooking', num);
        }}
      />
    </Box>
    <Box minHeight={56} display="flex" alignItems="flex-end">
      <TextField
        fullWidth
        label={ADDITIONAL_FIELDS_META.gridArchiveId.label}
        variant="standard"
        value={values.gridArchiveId ?? ''}
        disabled={isFieldsDisabled}
        onChange={handleTextChange('gridArchiveId')}
        onBlur={handleBlur('gridArchiveId')}
        onKeyDown={handleTextKeyDown('gridArchiveId')}
      />
    </Box>
  </>
);
